(function() {
  "use strict";

  angular

    .module("modules.dataServices", []);
})();